import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

function useLanguage() {
    const tran = useTranslation();
    const { i18n } = tran


    // i18n.language
    const [anchorEl, setAnchorEl] = useState(() => {
        
        let initLang = window.localStorage.getItem("Lang");
        if (!initLang) {
            const lang = navigator.language || navigator.userLanguage;
            if (lang === 'th-TH') {
                initLang = 'TH'
            } else if (lang === 'zh-CN') {
                initLang = '繁'
            } else {
                initLang = 'EN'
            }
        }
        return initLang
    });

    const checkoutLanguage = (language) => {
        setAnchorEl(language);
    }

    useEffect(() => {
        i18n.changeLanguage(anchorEl);
        window.localStorage.setItem("Lang", anchorEl);
    }, [anchorEl])

    return {
        lang: anchorEl,
        resources: Object.keys(tran.i18n.store.data),
        checkoutLanguage
    }
}

export default useLanguage